import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "tooltip-box" }

import type { ConfigDataProps, ExposeType } from "@/components/form";
import type { User } from "@/api/login";
import type { Result } from "@/plugins/axios";
import { useStore } from "@/store";
import { updateUserInfo } from "@/api/userCenter";
import { getUserInfo } from "@/api/login";
import { recover } from "@/plugins/keythereum";
import { message, Modal } from "ant-design-vue";
import { useRouter } from "@/router";
import { saveKeyChain } from "@/utils/hooks/systemKeychain";
import OTPInput from "@/components/OTPInput.vue";
import {
  ref,
  computed,
  reactive,
  toRaw,
  h,
  onMounted,
  nextTick,
} from "vue";
import { ExclamationCircleFilled } from "@ant-design/icons-vue";
import Form from "@/components/form/index.vue";
import { useCrypto } from "@/plugins/crypto/hook";
import { t } from "@/plugins/i18n";
import { Tooltip } from "ant-design-vue";

interface Props {
  resetPassword: boolean;
  color?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'getPrivateKey',
  props: {
    resetPassword: { type: Boolean },
    color: {}
  },
  emits: ["close", "screct"],
  setup(__props: any, { emit: __emit }) {

const showOTPInput = computed(() => {
  return !resetPassword && !!privateKey.value;
});
const prop = __props;

const router = useRouter();

const { resetPassword, color = "#4749ad" } = toRaw(prop);
const IS_ELECTRON = process.env.IS_ELECTRON;

const codeArray = ref(Array(6).fill(""));

const handleCodeUpdate = (newCode: string[]) => {
  console.log("newCode:", newCode);
  codeArray.value = newCode;
};
console.log("color:", color);

function six(value: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (/[^0-9]/g.test(value)) {
      return reject(t("userCenter.privateKey.onlyNumbers"));
    }

    if (value && (value as string).length !== 6)
      return reject(t("userCenter.privateKey.sixDigitsRequired"));

    return resolve();
  });
}

const store = useStore() as any;

const privateKey = computed(
  () => (store.state.user.userInfo as User)?.privateKey
);

const userId = (store.state.user.userInfo as User)?.id;

const publicKey = (store.state.user.userInfo as User)?.credential;

console.log("userinfo", store.state.user.userInfo);

const emit = __emit;

const open = ref(true);
const loading = ref(false);
const setRef = ref<ExposeType>();
const welcomeMessage = computed(() =>
  t("userCenter.privateKey.welcomeMessage")
);
const changeMessage = computed(() => t("userCenter.privateKey.changeMessage"));

const okBtnProps = computed(() => ({
  style: { background: showOTPInput.value ? color : "#4749ad" },
}));

const navigateToUserInfo = () => {
  if (IS_ELECTRON) {
    window.open(`${process.env.VUE_APP_H5_DOMAIN}/userCenter/userInfo`);
  } else {
    open.value = false;
    emit("close");
    router.push("/userCenter/userInfo");
  }
};

onMounted(() => {
  // 使用nextTick确保DOM已经渲染完成
  nextTick(() => {
    if (resetPassword || !privateKey.value) {
      // 如果是设置密码的表单，聚焦到第一个密码输入框
      const passwordInput = document.querySelector(
        'input[type="password"]'
      ) as HTMLInputElement;
      if (passwordInput) {
        passwordInput.focus();
      }
    } else {
      // 如果是验证密码的OTP输入框，聚焦到第一个输入框
      const otpInputs = document.querySelectorAll(".otp-input");
      if (otpInputs.length > 0) {
        (otpInputs[0] as HTMLInputElement).focus();
      }
    }
  });
});

const setConfig = {
  title: resetPassword
    ? t("userCenter.privateKey.setNewPassword")
    : t("userCenter.privateKey.setPassword"),
  type: "warning",
  message: t("userCenter.privateKey.setPasswordMessage"),
  ok: async () => {
    try {
      const res = await setRef.value?.validate();
      if (!res) return;
      const { encryptMessage, decryptPasswordToMessage } = await useCrypto();
      if (
        !publicKey ||
        typeof publicKey !== "string" ||
        publicKey.length < 64
      ) {
        throw new Error(t("userCenter.privateKey.passwordSetupFailed"));
      }
      let encryptResult: string;
      try {
        encryptResult = await encryptMessage(publicKey, res.password);
      } catch (encErr: any) {
        log.error("encryptMessage failed", encErr);
        throw new Error(
          (encErr && encErr.resultDesc) ||
            t("userCenter.privateKey.passwordSetupFailed")
        );
      }
      log.debug(
        "getPrivateKey encrypt password res",
        encryptResult?.slice(0, 10) + "..."
      );
      await updateUserInfo({
        id: userId,
        password: encryptResult,
      });
      const user = await getUserInfo();
      (store as any).commit("user/setUserInfo", user);
      const keystore = user.privateKey;
      if (!keystore)
        return Promise.reject(t("userCenter.privateKey.passwordMismatch"));
      const privateKey = recover({
        password: res.password as string,
        keystore: JSON.parse(keystore),
      });
      emit("screct", privateKey);
      // 敏感信息已移除：decryptPasswordToMessage 结果
      if (IS_ELECTRON) {
        saveKeyChain({
          userNo: (store.state.user.userInfo as User)?.userNo,
          privateKey,
        });
      }
      message.success(t("userCenter.privateKey.passwordSetSuccess"));
      return;
    } catch (e: any) {
      if (e.errorFields?.length > 0) {
        return;
      }
      message.error(
        (e as Result).resultDesc ||
          t("userCenter.privateKey.passwordSetupFailed")
      );
      log.error(e);
    }
  },
  cancel: async () => {
    open.value = false;
    emit("close");
  },
};

const setform = reactive<ConfigDataProps>({
  password: {
    label: t("userCenter.privateKey.setPassword"),
    value: undefined,
    antType: "inputPassword",
    rules: [
      {
        required: true,
        validator: async (_: unknown, value: string) => six(value),
        trigger: "blur",
      },
    ],
    bind: {
      placeholder: t("userCenter.privateKey.enterSixDigitPassword"),
      autocomplete: "off",
      maxlength: 6,
    },
  },
  repassword: {
    label: t("userCenter.privateKey.confirmPassword"),
    value: undefined,
    antType: "inputPassword",
    rules: [
      {
        required: true,
        validator: async (_: unknown, value: string) => {
          await six(value as string);
          if (value !== setform.password.value) {
            return Promise.reject(t("userCenter.privateKey.passwordMismatch"));
          }
          return Promise.resolve();
        },
        trigger: "blur",
      },
    ],
    bind: {
      placeholder: t("userCenter.privateKey.enterSixDigitPassword"),
      autocomplete: "off",
      maxlength: 6,
    },
  },
});

const putConfig = {
  title: t("userCenter.privateKey.enterPassword"),
  type: "info",
  message: t("userCenter.privateKey.enterPasswordMessage"),
  ok: async () => {
    try {
      const password = codeArray.value.join("");
      // 敏感信息已移除
      // 验证输入
      if (!password) {
        message.error(t("userCenter.privateKey.pleaseEnterPassword"));
        return;
      }
      if (password.length !== 6) {
        message.error(t("userCenter.privateKey.sixDigitsRequired"));
        return;
      }

      const res = recover({
        password,
        keystore: JSON.parse(privateKey.value || "{}"),
      });
      console.log("res:", res);
      emit("screct", res);
      if (IS_ELECTRON) {
        saveKeyChain({
          userNo: (store.state.user.userInfo as User)?.userNo,
          privateKey: res,
        });
      }
    } catch (e) {
      message.error(t("userCenter.privateKey.incorrectPassword"));
    }
  },
  cancel: async () => {
    open.value = false;
    emit("close");
  },
};

const config = computed((() =>
  !resetPassword && privateKey.value ? putConfig : setConfig) as () => {
  title: string;
  type: "info" | "warning";
  message: string;
  ok: () => Promise<void>;
  cancel: () => Promise<void>;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Modal), {
      open: open.value,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
      title: config.value?.title,
      maskClosable: false,
      confirmLoading: loading.value,
      onOk: config.value?.ok,
      onCancel: config.value?.cancel,
      "ok-text": _unref(t)('userCenter.confirm'),
      "cancel-text": _unref(t)('userCenter.cancel'),
      class: _normalizeClass(`${showOTPInput.value ? 'otp-modal' : ''}`),
      okButtonProps: okBtnProps.value as any
    }, {
      default: _withCtx(() => [
        (!privateKey.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
              _createVNode(_unref(ExclamationCircleFilled), { style: {"color":"#4749ad"} }),
              _createElementVNode("span", {
                class: "ml-2",
                innerHTML: welcomeMessage.value
              }, null, 8, _hoisted_2)
            ]))
          : (_unref(resetPassword))
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _createVNode(_unref(ExclamationCircleFilled), { style: {"color":"#4749ad"} }),
                _createElementVNode("span", {
                  class: "ml-2",
                  innerHTML: changeMessage.value
                }, null, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
        (_unref(resetPassword) || !privateKey.value)
          ? (_openBlock(), _createBlock(Form, {
              key: 2,
              class: "content",
              ref_key: "setRef",
              ref: setRef,
              "config-data": setform,
              autocomplete: "off",
              configLayout: { labelCol: { span: 0 }, wrapperCol: { span: 24 } }
            }, null, 8, ["config-data"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(OTPInput, {
                "onUpdate:code": handleCodeUpdate,
                color: _unref(color)
              }, null, 8, ["color"]),
              _createVNode(_unref(Tooltip), { placement: "rightTop" }, {
                title: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("userCenter.privateKey.authPasswordDescription")) + " ", 1),
                    _createElementVNode("a", {
                      style: { color: '#797DFF', cursor: 'pointer' },
                      onClick: navigateToUserInfo
                    }, _toDisplayString(_unref(t)("userCenter.privateKey.personalInfoLink")), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(t)("userCenter.privateKey.resetInstructions")), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_6, [
                    _createVNode(_unref(ExclamationCircleFilled), {
                      style: _normalizeStyle({
                marginRight: '4px',
                color: _unref(color) === '#4749ad' ? _unref(color) : '#ff9432',
              })
                    }, null, 8, ["style"]),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)("userCenter.privateKey.whatIsAuthPassword")), 1)
                  ])
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    }, 8, ["open", "title", "confirmLoading", "onOk", "onCancel", "ok-text", "cancel-text", "class", "okButtonProps"])
  ]))
}
}

})